import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * The round ✕ that closes a workspace main-content pane (patient, view, empty
 * room). Sits at the top-right of the pane, beside a folder's tab; `onClick`
 * returns to whatever the pane's close goes back to (usually the rooms grid).
 *
 * Neutral paper: annotation ink that darkens into a recess on hover, so it reads
 * the same on the page as on a folder's manila.
 */
export const ClosePaneButton = ({
  onClick,
  label = "Close",
  dataTestId,
}: {
  onClick: () => void;
  /** Accessible label; defaults to "Close". */
  label?: string;
  dataTestId?: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    // Fixed rather than `label`: the accessible label is a caller's string, and
    // a caller that one day names the pane after its patient would put that
    // name in the action name.
    data-dd-action-name="Close pane"
    data-testid={dataTestId}
    className="flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-annotation transition duration-150 ease-paper hover:bg-recess hover:text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
  >
    <FontAwesomeIcon icon={faXmark} />
  </button>
);
